
/**
 * Represents a single update to the application state, which can include a set
 * of any number of property changes. AppStateUpdate instances are used to either immediately
 * update the current state, or buffered future state updates for later application.
 */
export class AppStateUpdate {
  constructor (appState, targetState) {
    this.appState = appState;
    this.targetState = targetState;
    this.updates = new Map();
  }

  setPrimitiveProperty (name, newValue) {
    this.updates.set(name, {type:'primitive', value:newValue})
  }

  setCompositeProperty (name, newValue) {
    this.updates.set(name, {type:'composite', value:newValue})
  }

  setDirectProperty (name, newValue) {
    this.updates.set(name, {type:'direct', value:newValue});
  }

  commit (quiet = false) {
    this.updates.forEach((update, prop) => {
      if (update.type === 'primitive') {
        this.appState.setPrimitiveProperty(prop, update.value, quiet);
      } else if (update.type === 'composite') {
        this.appState.setCompositeProperty(prop, update.value, quiet);
      } else if (update.type === 'direct') {
        if (quiet) {
          this.appState.quietSet(prop, update.value);
        } else {
          this.appState[prop] = update.value;
        }
      }
    });
  }
}